import {
  Button,
  Flex,
  IconButton,
  InputGroup,
  Text,
  useBoolean,
  useToast
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";

import { Input as InputForm } from "@/components/Input";
import { AuthContext, useAuth } from "@/contexts";
import Router from "next/router";
import { useContext, useState } from "react";

type Inputs = {
  email: string;
  password: string;
};

interface CardLoginProps {
  checkout?: boolean;
  closeFn?: () => void;
}

export function CardLogin({ checkout, closeFn }: CardLoginProps) {
  const { handleSubmit, register } = useForm();
  const [ShowPassword, setShow] = useBoolean();
  const [email, setEmail] = useState(String);
  const [password, setPassword] = useState(String);
  const User = useAuth();
  const toast = useToast({
    position: "bottom",
    duration: 3000,
    isClosable: true
  });

  const { signIn } = useContext(AuthContext);
  async function handleSignIn(data: Inputs) {
    signIn({ UserEmail: email, password })
      .then((response) => {
        if (response.status) {
          toast.closeAll();
          toast({
            title: "Login realizado com sucesso",
            status: "success",
            containerStyle: {
              color: "white",
              fontFamily: "arial",
              fontWeight: "100"
            },
            onCloseComplete: () => {
              if (checkout) {
                Router.push("/checkout/entrega");
                return;
              }
              if (Router.pathname === "/login") {
                Router.push("/minhaconta");
                return;
              } else if (Router.pathname === "/cadastro") {
                Router.push("/login");
                return;
              } else {
                Router.push(Router.pathname);
                return;
              }
            }
          });
        } else {
          toast.closeAll();
          toast({
            title: "Erro ao realizar login",
            status: "error",
            description: response.message
          });
        }
      })
      .catch((error) => {
        toast.closeAll();
        toast({
          title: "Erro ao realizar login",
          status: "error",
          description: error.message
        });
      });
  }

  return (
    <Flex
      w="full"
      as="form"
      mt={"20px"}
      justify="center"
      onSubmit={handleSubmit(handleSignIn)}
    >
      <Flex w="300px" direction="column" alignItems="center">
        <InputForm
          {...register("email", {
            value: email,
            onChange: (e) => setEmail(e.target.value)
          })}
          id={"LoginEmail"}
          as="input"
          type="email"
          borderRadius={"5px"}
          borderColor="#A9A9A9"
          placeholder="E-mail"
          border="1px solid"
          w={["full", "full"]}
          mb="1rem"
        />
        <InputGroup
          display="flex"
          alignItems="center"
          mb="2rem"
          border="1px solid"
          borderColor="#A9A9A9"
          borderRadius={"5px"}
          _hover={{
            borderColor: "black"
          }}
          _focus={{
            borderColor: "black"
          }}
        >
          <InputForm
            {...register("password", {
              value: password,
              onChange: (e) => setPassword(e.target.value)
            })}
            as="input"
            id={"LoginPassword"}
            borderColor="white"
            borderRadius={"5px"}
            type={ShowPassword ? "text" : "password"}
            placeholder="Senha"
            w={["full", "full"]}
            _hover={{
              borderColor: "none"
            }}
            _focus={{
              borderColor: "black"
            }}
          />
          <IconButton
            aria-label="Mostrar senha"
            variant="none"
            icon={ShowPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
            onClick={setShow.toggle}
            _focus={{ border: "none" }}
          />
        </InputGroup>

        <Button
          bgColor="#128A15"
          color={"white"}
          borderRadius="5px"
          textStyle={"Regular"}
          _hover={{ opacity: "80%" }}
          type="submit"
          w="full"
        >
          ACESSAR CONTA
        </Button>
        <Text my=".5rem">OU</Text>
        <Button
          bgColor="#121212"
          color={"white"}
          borderRadius="5px"
          textStyle={"Regular"}
          _hover={{ bg: "#FF003A" }}
          w="full"
          onClick={() => Router.push("/recuperar-senha/enviar-email")}
        >
          RECUPERAR SENHA
        </Button>
      </Flex>
    </Flex>
  );
}
